import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { settingsPageStyles } from "component/shared/settings-page";

export const styles = (theme: Theme) => {
	return ({
		...settingsPageStyles(theme),
		planValue: {
			fontSize: 16,
			color: theme.palette.custom.textPrimary,
		},
		bannerBody: {
			fontSize: 16,
			color: theme.palette.custom.textPrimary,
		},
		bannerContactRow: {
			display: "flex",
			alignItems: "center",
			gap: 8,
			marginTop: 8,
			fontWeight: "bold",
			fontSize: 16,
			color: theme.palette.custom.textPrimary,
		},
		bannerClientId: {
			fontSize: 16,
			color: theme.palette.custom.textPrimary,
			marginTop: 8,
		},
		// Checkbox at x=0 and its label at x=40 (24 + 16), the same column disclosedFields indents to,
		// so revealed fields line up with the label. Dropping the checkbox padding also brings the row
		// to a true 16px below the field above it (MAX-4356).
		checkboxRow: {
			marginLeft: 0,
			marginRight: 0,
			gap: 16,
			"& .MuiCheckbox-root": {
				padding: 0,
			},
		},
		disclosedFieldStack: {
			display: "flex",
			flexDirection: "column",
			gap: 16,
			marginTop: 16,
		},
		checkboxLabel: {
			fontSize: 16,
			color: theme.palette.custom.textPrimary,
		},
		cancelLink: {
			color: theme.palette.error.main,
			fontWeight: "bold",
			fontSize: 16,
			padding: 0,
			minWidth: 0,
			textTransform: "none",
			"&:hover": {
				backgroundColor: "transparent",
				textDecoration: "underline",
			},
		},
		cancelModalBlock: {
			backgroundColor: theme.palette.custom.tableHeaderSurface,
			padding: 16,
			borderRadius: 4,
		},
		cancelModalText: {
			whiteSpace: "pre-line",
			fontSize: 16,
			color: theme.palette.custom.textPrimary,
			marginTop: 8,
		},
		cancelModalCopy: {
			padding: 0,
			minWidth: 0,
			textTransform: "none",
			fontSize: 14,
		},
		// Same tab bar as the refreshed profile (shared/profile-refresh), left-aligned under the subtitle.
		tabBar: {
			display: "flex",
			marginBottom: theme.spacing(3),
			[theme.breakpoints.down("sm")]: {
				overflowX: "auto",
				WebkitOverflowScrolling: "touch",
			},
		},
		tab: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			gap: 6,
			padding: 0,
			flexShrink: 0,
			cursor: "pointer",
			fontFamily: theme.typography.fontFamily,
			fontSize: 16,
			fontWeight: 400,
			lineHeight: "24px",
			color: theme.palette.custom.textTertiary,
			background: "none",
			border: "none",
			outline: "none",
		},
		tabLabel: {
			padding: "0 16px",
		},
		tabActive: {
			color: theme.palette.custom.textPrimary,
		},
		tabUnderline: {
			width: "100%",
			height: 2,
			backgroundColor: theme.palette.custom.borderCard,
		},
		tabUnderlineActive: {
			backgroundColor: theme.palette.custom.primary,
		},
	} satisfies Record<string, CSSObject>);
};
